import { z } from "zod";

import { collectionSchema } from "../collection/collectionSchema";
import { playableMediaSchema } from "../playableMediaSchema";
import { basePrayerSchema } from "../prayer/basePrayerSchema";
import { radioSongSchema } from "../radio-station/radioSongSchema";
import { radioStationSchema } from "../radio-station/radioStationSchema";
import { selectableGuideSchema } from "../selectableGuideSchema";

export const prayerQueueItemSchema = z.object({
  collection: collectionSchema.omit({
    prayers: true,
  }),
  prayer: basePrayerSchema.extend({
    selectable_guides: z.array(selectableGuideSchema),
  }),
  selected_audio: playableMediaSchema,
  type: z.literal("prayer"),
});

export const radioQueueItemSchema = z.object({
  radio_song: radioSongSchema.optional(),
  radio_station: radioStationSchema.optional(),
  selected_audio: playableMediaSchema,
  type: z.literal("radio_song"),
});

export const queueItemSchema = prayerQueueItemSchema.or(radioQueueItemSchema);

export type QueueItem = z.infer<typeof queueItemSchema>;
export type PrayerQueueItem = z.infer<typeof prayerQueueItemSchema>;
export type RadioQueueItem = z.infer<typeof radioQueueItemSchema>;
export type PrayerQueueItemShape = typeof prayerQueueItemSchema.shape;
export type RadioQueueItemShape = typeof radioQueueItemSchema.shape;
